import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { getNs } from 'common/i18n-config'

import { AINotice } from './ai-notice'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])

type AIDisclaimerProps = {
  className?: string
}

export const AIDisclaimer = ({ className }: AIDisclaimerProps) => {
  useNsReady()

  return <AINotice className={className} icon={faCircleInfo} text={t('reference_information_disclaimer')} />
}
